import { gql } from '@apollo/client';

// query that describes which roles the user can create if he has the permissions
export const GET_AGENT_AVAILABLE_ROLES = gql`
  query GetAgentAvailableRoles {
    getAvailableRolesForAgent {
      ID
      description
      name
    }
  }
`;
